import { useCallback, useEffect } from "react";
import { checkIsToShowCaraousal, extractParams, getLocalStorage, initializeAuth, setLocalStorage } from "../utils/Utils";
import {  STORAGE_KEY, REACT_APP_SWAN_API_SERVER_URL } from "../services/constant";
import { userVerify } from "../utils/Utils";
import { IMAGES_DATA } from "../services/ImagesData";

const useGetParams = ({ attributesData, setDetails }) => {
	const initialize = useCallback(async () => {
		if (!attributesData) return;
		const { shopDomain, product, addToCart, name, email,redirectUrl } = attributesData;
		if (!shopDomain || !product?.handle) return;
		const { email: paramEmail, token, fit, cart } = extractParams(window.location.search);
		if (token) {
			await userVerify(REACT_APP_SWAN_API_SERVER_URL, token);
		}
		console.log(paramEmail,"param email");
		console.log(email,"email");
		let finalEmail =  email || paramEmail || getLocalStorage(STORAGE_KEY.EMAIL)
		await initializeAuth({ email:finalEmail, name, shopDomain });
	    finalEmail = finalEmail || getLocalStorage(STORAGE_KEY.EMAIL);
		console.log(finalEmail,"finalEmail");
		if (finalEmail) setLocalStorage(STORAGE_KEY.EMAIL, finalEmail);
		const scanId =  getLocalStorage(STORAGE_KEY.SCAN_ID);
		const faceScanId =  getLocalStorage(STORAGE_KEY.FACE_SCAN_ID);
		const jwtToken = getLocalStorage(STORAGE_KEY.JWTToken);
		console.log(scanId,"before alocation");
		console.log({
			token: jwtToken,
			email: finalEmail,
			scanID:  (checkIsToShowCaraousal({shopDomain}) ? IMAGES_DATA?.[product?.handle]?.scanId : scanId),
			shopifyRedirectUrl: redirectUrl || window.location.href,
			faceScanId
		},"above set");
		
		setDetails({
			token: jwtToken,
			email: finalEmail,
			scanID:checkIsToShowCaraousal({shopDomain}) ? IMAGES_DATA?.[product?.handle]?.scanId : scanId,
			shopifyRedirectUrl: redirectUrl || window.location.href,
			faceScanId
		});
		if (fit && cart) {
			addToCart?.(fit);
		}
	}, [attributesData, setDetails]);

	useEffect(() => {
		initialize();
	}, [initialize]);

	return null;
};

export default useGetParams;
